import './social_content_details_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SurveyContentDetailsView extends Monitoring.Views.SocialContents.SocialContentDetailsView
  render: ->
    @_renderSurveyTimestamp()
    @_renderContentID()
    @

  _renderSurveyTimestamp: ->
    @$el.append new Monitoring.Views.SocialContents.SocialContentDetailsSurveyTimestampView(
      timestamp: moment(@model.created_at().replace(' ', '')) #ugly but fast
    ).render().el

  _renderContentID: ->
    @$el.append new Monitoring.Views.SocialContents.SocialContentDetailsContentIDView(
      id: @model.externalId()
    ).render().el
